<template>
    <router-view/>
</template>

<script>
    export default {
        name: "v_langCode"
    }
</script>

<style scoped>

</style>